import { getSerializer } from '@shared/serializers/serializer';

export const assetsCategory = {
  type: 'assetcategory',
  attributes: [
    'name', 'responsibleUsers', 'subLocations'
  ],
};

export const AssetsCategorySerializer = getSerializer(assetsCategory);
